import React, { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import useMaintenanceText from "./useMaintenanceText";
import "./MaintenanceBanner.css";

const MaintenanceIcon = () => (
  <i className="fas fa-exclamation-triangle maintenance-banner__icon" aria-hidden="true" />
);

const MaintenanceBanner = forwardRef(({ item, onClose, onDontShow }, ref) => {
  const { t } = useTranslation("common");
  const { window } = item;

  const { title, scheduleText, durationText, impactText } =
    useMaintenanceText(window);

  return (
    <div ref={ref} className="maintenance-banner" role="alert">
      <MaintenanceIcon />
      <span className="maintenance-banner__title">{title}</span>
      <span className="maintenance-banner__sep">—</span>
      <span className="maintenance-banner__schedule">
        {scheduleText}
        {durationText && <>{" — "}{durationText}</>}
      </span>
      <span className="maintenance-banner__sep">·</span>
      <span className="maintenance-banner__desc">{impactText}</span>
      <div className="maintenance-banner__actions">
        <button type="button" className="maintenance-banner__btn" onClick={onDontShow}>
          {t("maintenanceBanner.dontShowAnymore")}
        </button>
        <button type="button" className="maintenance-banner__btn" onClick={onClose}>
          {t("generic.close", { defaultValue: "Close" })}
        </button>
      </div>
    </div>
  );
});

MaintenanceBanner.displayName = "MaintenanceBanner";

MaintenanceBanner.propTypes = {
  item: PropTypes.shape({
    window: PropTypes.shape({
      maintenanceWindowGuid: PropTypes.string.isRequired,
      translationKey: PropTypes.string,
      status: PropTypes.string.isRequired,
      startDateUtc: PropTypes.string.isRequired,
      plannedEndDateUtc: PropTypes.string.isRequired,
      completionDateUtc: PropTypes.string,
      possibleDataLoss: PropTypes.bool.isRequired,
      loginAvailable: PropTypes.bool.isRequired,
      severity: PropTypes.number.isRequired,
      description: PropTypes.string,
    }).isRequired,
    userAckType: PropTypes.string,
    userAckedAtUtc: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onDontShow: PropTypes.func.isRequired,
};

export default MaintenanceBanner;
